import debug from 'debug';
import Sorting from 'Global/Shared/Components/Sorting/Sorting';
import CloudApi from 'Minetilbud/Shared/Components/CloudApi/Customers';
import Categories from './categories';
import Favorites from './favorites';
import Settings from './settings';

const log = debug('FrontPageCatalogs:Data:Customers');

class Customers {
	static all;
	static dataset;
	static numberOfFeedCatalogs;
	static numberOfPaperCatalogs;

	/**
	 * @returns {Promise} customers
	 */
	async get() {
		if (Customers.dataset !== undefined) return Customers.dataset;

		try {
			const cloudapi = new CloudApi();
			const response = await cloudapi.CustomersWithLinksAndCatatalogs({
				customerType: Settings.customerType,
				showFeedCatalogs: Settings.showFeedCatalogs
			});
			
			if (response.status !== 200) {
				Categories.set([]);
				Customers.dataset = [];
				return [];
			}

			const dataset = await response.json();
			Categories.set(dataset.categories);
			Customers.dataset = dataset;

			log('---- Favorites', Favorites.dataset);
			this.setProperties();
			
			return dataset;
		} catch(error) {
			log('get() - error', error);
		}
	}

	/**
	 * Adds {object} catalogs property to customers
	 * @param {Objext} catalog 
	 * @param {number} customerIndex 
	 */
	setCatalogsProperty(catalog, customerIndex) {
		if (Customers.all[customerIndex].catalogs === undefined) {
			Customers.all[customerIndex].catalogs = [];
		}

		Customers.all[customerIndex].catalogs.push(catalog);
	}

	/**
	 * Adds {object} catalogs property to customers
	 * @param {Objext} catalog 
	 * @param {number} customerIndex 
	 */
	setCategoriesProperty(catalog, customerIndex) {
		if (Customers.all[customerIndex].categories === undefined) {
			Customers.all[customerIndex].categories = [];
		}

		if (catalog.primaryCategory === null) {
			log('setCategoriesProperty() - catalogUrl, primaryCategory', catalog.catalogUrl, catalog.primaryCategory);
			return;
		}

		const primaryCategoryId = catalog.primaryCategory.id;
		Customers.all[customerIndex].categories.push({
			id: primaryCategoryId,
			name: catalog.primaryCategory.name,
			type: 'primary'
		});

		catalog.secondaryCategories.map(secondaryCategory => {
			if (secondaryCategory.id !== primaryCategoryId) {
				Customers.all[customerIndex].categories.push({
					id: secondaryCategory.id,
					name: secondaryCategory.name,
					type: 'secondary'
				});
			}
		});

	}

	/**
	 * Adds {number} date property to customers (number of milliseconds since 1 January, 1970, 00:00:00 UTC)
	 * @param {Objext} catalog 
	 * @param {number} customerIndex 
	 */
	setDateProperty(catalog, customerIndex) {
		const publishStart = Date.parse(catalog.publishStart);

		if (Customers.all[customerIndex].date === undefined) {
			Customers.all[customerIndex].date = publishStart;
		} 

		if (publishStart > Customers.all[customerIndex].date) {
			Customers.all[customerIndex].date = publishStart;
		}
	}

	/**
	 * Adds {boolean} isFavourite property to customers. The property only exist when the user is logged in
	 * @param {object} options 
	 * @param {string} options.customerId 
	 * @param {number} [options.customerIndex] 
	 * @param {boolean} [options.enabled] 
	 */
	setIsFavoriteProperty(options) {
		let customerIndex = options.customerIndex;
		if (customerIndex === undefined) {
			customerIndex = Customers.all.findIndex(customer => customer.id === options.customerId);
		}

		if (customerIndex === -1) return;

		if (options.enabled !== undefined) {
			Customers.all[customerIndex].isFavorite = options.enabled;
			return;
		}

		if (Favorites.dataset === undefined) {
			Customers.all[customerIndex].isFavorite = false;
			return;
		}
		const favoriteIndex = Favorites.dataset.findIndex(favorite => favorite.customerid === options.customerId);
		Customers.all[customerIndex].isFavorite = favoriteIndex > -1 ? true : false;
	}

	/**
	 * Adds {boolean} isFeed property to customers
	 * @param {Objext} catalog 
	 * @param {number} customerIndex 
	 */
	setIsFeedProperty(catalog, customerIndex) {
		if (Customers.all[customerIndex].isFeed === undefined) {
			Customers.all[customerIndex].isFeed = false;
		}

		if (catalog.isFeed) {
			Customers.all[customerIndex].isFeed = true;
		} 
	}

	/**
	 * Adds {boolean} isOnline property to customers
	 * @param {Objext} catalog 
	 * @param {number} customerIndex 
	 */
	setIsOnlineProperty(catalog, customerIndex) {
		if (Customers.all[customerIndex].isOnline === undefined) {
			Customers.all[customerIndex].isOnline = false;
		}

		if (catalog.isFeed || catalog.hasLinks) {
			Customers.all[customerIndex].isOnline = true;
		} 
	}

	setProperties() {
		let numberOfPaperCatalogs = 0;
		let numberOfFeedCatalogs = 0;

		Customers.all =  Customers.dataset.customers;
		const catalogs = Customers.dataset.catalogs.sort(Sorting.by('-publishStart'));

		catalogs.map(catalog => {
			const customerIndex = Customers.all.findIndex(customer => customer.id === catalog.customerId);

			if (customerIndex === -1) return;

			this.setCatalogsProperty(catalog, customerIndex);
			this.setCategoriesProperty(catalog, customerIndex);
			this.setDateProperty(catalog, customerIndex);
			this.setIsFavoriteProperty({
				customerId: catalog.customerId,
				customerIndex: customerIndex
			})
			this.setIsFeedProperty(catalog, customerIndex);
			this.setIsOnlineProperty(catalog, customerIndex);

			if (catalog.isFeed) {
				numberOfFeedCatalogs++;
			}
			else {
				numberOfPaperCatalogs++
			}
		});

		Customers.numberOfFeedCatalogs = numberOfFeedCatalogs;
		Customers.numberOfPaperCatalogs = numberOfPaperCatalogs;
	}
}

export default Customers;
